const NextSteps = ({ className = '' }) => {
  return (
    <ol className={`space-y-2 ${className}`}>
      <li className="flex items-center gap-3">
        <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-ink text-[11px] font-semibold text-white">1</span>
        <span className="text-[12px] text-ink">Send your order on WhatsApp</span>
      </li>
      <li className="flex items-center gap-3">
        <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-ink text-[11px] font-semibold text-white">2</span>
        <span className="text-[12px] text-ink">Pay securely with the Razorpay link we send</span>
      </li>
      <li className="flex items-center gap-3">
        <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-ink text-[11px] font-semibold text-white">3</span>
        <span className="text-[12px] text-ink">Share your details. Live within 24 hours.</span>
      </li>
    </ol>
  );
};

export default NextSteps;
